<template>
    <fade-transition data-delay="delay" :duration="{enter: 500, leave: 10}" mode="out-in" appear>
        <div v-if="mediasShow" :class="listClass">
            <ul class="videoListWrapper">
                <li v-for="(media, index) in medias"
                    :key="media.slug"
                    :class="mediaClasses(index)"
                    @mouseover="onHover(media)"
                    @mouseleave="onLeave"
                    @click="emulateHover(media)"
                >
                    <router-link :to="mediaPath(media)"
                                 :class="[
                                     'videoList__innerLink',
                                    {'videoList__innerLink-hovered': hover === media},
                                    {'videoList__innerLink-fullMedia': mediaClass === 'full-media'},
                                 ]"
                    >
                        <img class="videoList__videoThumbnail"
                             v-lazy="cover(media)"
                             alt=""
                        />

                        <div class="videoList__videoInfoWrapper">
                            <div class="videoList__videoInfoInner">
                                <div class="videoList__videoBrand">
                                    {{ mediaProps(media).client }}
                                </div>
                                <div class="videoList__videoName">
                                    {{ mediaProps(media).title }}
                                </div>
                                <div class="videoList__editorName">
                                    {{ credits(media, 'editor') }}
                                </div>
                            </div>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>
    </fade-transition>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import {gridMixin,} from "../mixins/shared";
import {mediaProps} from "../utils/shared";

export default {
    props: ['listClass', 'mediaClass', 'delay', 'medias', 'gridSize'],
    mixins: [gridMixin],
    data() {
        return {
            mediasShow: false,
            hover: null,
        }
    },
    computed: {
        ...mapGetters('ui', [
            'isTouch',
        ]),
        mediaPath(media) {
            return (media) => {
                return !this.isTouch || media === this.hover
                    ? {path: media.link}
                    : ''
            }
        },
    },
    created() {
        //console.log('created: features')
    },
    mounted() {
        this.mediasShow = true
    },
    watch: {
        medias: {
            handler: 'onMediasChanged',
            immediate: true,
        },
    },
    methods: {
        mediaClasses(index) {
            return [
                'videoList',
                this.$_getGridClasses(index),
            ]
        },
        onMediasChanged(new_) {
            this.$_calculateGrid(new_)
        },
        cover(media) {
            return media.thumbs.large.url;
        },
        mediaProps(media) {
            return mediaProps.get(media)
        },
        credits(media, section) {
            let credits = media.credits

            return credits[section] && credits[section].name
                ? credits[section].name
                : ''
        },
        onHover(media) {
            if (this.isTouch) {
                return
            }

            this.hover = media
        },
        onLeave() {
            if (this.isTouch) {
                return
            }

            this.hover = null
        },
        emulateHover(media) {
            if (!this.isTouch) {
                return
            }

            this.hover = media
        },
    },
}
</script>

